import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
const resources = {
  ar: {
    translation: {
      "home": "الرئيسية",
      "services": "خدماتنا",
      "gallery": "معرض الصور",
      "about": "من نحن",
      "contact": "اتصل بنا",
      "welcome": "مرحباً بكم في نيو كلين",
      "slogan": "نظافة متميزة لحياة أفضل",
      "services_title": "خدماتنا المتميزة",
      "service1": "تنظيف المنازل",
      "service1_desc": "خدمات تنظيف شاملة للمنازل والشقق بأعلى معايير الجودة",
      "service2": "تنظيف المكاتب",
      "service2_desc": "خدمات احترافية لتنظيف المكاتب والشركات",
      "service3": "تنظيف السجاد",
      "service3_desc": "تنظيف عميق للسجاد والموكيت باستخدام أحدث التقنيات",
      "service4": "تنظيف الواجهات",
      "service4_desc": "تنظيف واجهات المباني والنوافذ بمعدات متطورة",
      "gallery_title": "معرض أعمالنا",
      "about_title": "من نحن",
      "about_desc": "شركة نيو كلين هي شركة متخصصة في مجال خدمات النظافة، تأسست بهدف تقديم خدمات تنظيف متميزة بأعلى معايير الجودة. نحن نستخدم أحدث التقنيات والمعدات لضمان نتائج مثالية ترضي عملائنا.",
      "contact_title": "اتصل بنا",
      "address": "الخرطوم · الصحافة تقاطع باشدار",
      "phone": "00249114643934",
      "email": "info@newclean.com",
      "footer": "جميع الحقوق محفوظة © نيو كلين 2025"
    }
  },
  en: {
    translation: {
      "home": "Home",
      "services": "Services",
      "gallery": "Gallery",
      "about": "About",
      "contact": "Contact",
      "welcome": "Welcome to New Clean",
      "slogan": "Superior Cleaning for a Better Life",
      "services_title": "Our Premium Services",
      "service1": "Home Cleaning",
      "service1_desc": "Comprehensive cleaning services for homes and apartments with the highest quality standards",
      "service2": "Office Cleaning",
      "service2_desc": "Professional services for cleaning offices and companies",
      "service3": "Carpet Cleaning",
      "service3_desc": "Deep cleaning of carpets using the latest technologies",
      "service4": "Facade Cleaning",
      "service4_desc": "Cleaning building facades and windows with advanced equipment",
      "gallery_title": "Our Work Gallery",
      "about_title": "About Us",
      "about_desc": "New Clean is a company specialized in cleaning services, established with the aim of providing distinguished cleaning services with the highest quality standards. We use the latest technologies and equipment to ensure perfect results that satisfy our customers.",
      "contact_title": "Contact Us",
      "address": "Khartoum · Al-Sahafa Bashdar Intersection",
      "phone": "00249114643934",
      "email": "info@newclean.com",
      "footer": "All Rights Reserved © New Clean 2025"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ar", // default language
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
